import { boxShadow, dropShadow, spacing } from '@/styles/theme/theme-tokens'

/**
 * Structural chart theme (spacing / padding / shadows / z-index) consumed by the
 * chart tooltips.
 *
 * Colours are NOT here: charts render in Highcharts styled mode (every SVG element
 * is coloured from `charts.css` via `@repo` CSS vars) and the `useHTML` tooltips
 * read the `@repo` vars directly (see `highcharts.ts`). Spacing follows the legacy
 * V5 shifted map. Light and dark are structurally identical, so both exports point
 * at one object — `themeMode` (from `useChartTheme`) drives light/dark via CSS.
 */
export interface ChartTheme {
  spacing: { xxs: string; xs: string; s: string; m: string; l: string }
  padding: { s: string; m: string }
  boxShadow: { dp2: string; dp4: string }
  dropShadow: { dp2: string }
  zIndex: {
    dropdown: { mid: string | number }
    overlay: { mid: string | number }
  }
}

// V5 mapping (themes.ts): spacing { xxs: 2xs, xs: xs, s: s, m: l, l: xl } and
// padding { s: m, m: l } — intentionally shifted vs the tailwind token names.
const commonChartTheme: ChartTheme = {
  spacing: {
    xxs: spacing['2xs'],
    xs: spacing.xs,
    s: spacing.s,
    m: spacing.l,
    l: spacing.xl
  },
  padding: {
    s: spacing.m,
    m: spacing.l
  },
  boxShadow: {
    dp2: boxShadow.dp2,
    dp4: boxShadow.dp4
  },
  dropShadow: {
    dp2: dropShadow.dp2
  },
  // Highcharts-internal tooltip stacking (SVG context, not the app z-index convention)
  zIndex: {
    dropdown: { mid: 100 },
    overlay: { mid: 1000 }
  }
}

export const lightChartTheme = commonChartTheme
export const darkChartTheme = commonChartTheme
